import { productKeys, useAppService, useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import { assertNotUndefined } from "utils/hx/util/types";

export const useGetProducibleProductsQuery = () => {
  const service = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());
  return useQuery({
    queryKey: productKeys.getProducible(organisationId),
    queryFn: () =>
      service.getThirdPartySaleFinishableProductListings({
        organisationId,
        searchTerm: null,
      }),
  });
};
